export const locale = {
  lang: 'zh1',
  data: {
    'CHANGELOG': {
      'TITULO': '變更日誌',
      'SUBTITULO': '隨著時間的推移檢查對平台所做的更新',
      'ULTIMA': '最後更新',
      'CATEGORIAS': {
        'Changed': '更新',
        'Fixed': '修復',
        'Added': '改進'
      }
    },
    'KNOWLEDGE': {
      'LINK': '如果平台沒有自動重定向您，請單擊此鏈接'
    }
  }
};
